module.exports = __webpack_public_path__ + "img/tienda.87a17b30.png";